import { TextBox } from "@progress/kendo-react-inputs";
import React from "react";
import { TextBoxChangeEvent } from "@progress/kendo-react-inputs";

interface InputProps {
  name: string;
  value: string | null;
  onChange: (value: string | number | readonly string[] | undefined) => void;
  readOnly?: boolean;
}

const Input: React.FC<InputProps> = ({ name, value, onChange, readOnly }) => {

  const handleChange = (e: TextBoxChangeEvent) => {
    onChange(e.target.value);
  };

  return (
    <div className="inputConnexion">
      <p>{name}</p>
      <TextBox
        autoComplete="user"
        value={value !== null ? value : ""}
        onChange={handleChange}
        // placeholder={name}
        required={true}
        readOnly={readOnly}
      />
    </div>
  );
};
export default Input;
